const mutations = {
  mutationTheme(state, payload) {
    state.colorTheme = payload;
  },

  mutationLogo(state, payload) {
    state.logo = payload;
  },

  mutationSidebarMenuDefault(state, payload) {
    state.sidebarMenuDefault = payload;
  },

  mutationSidebarMenu(state, payload) {
    state.sidebarMenu = payload;
  },

  mutationHeaderPolicies(state, payload) {
    state.headerPolicies = payload;
  },

  mutationHeaderClaims(state, payload) {
    state.headerClaims = payload;
  },

  mutationPreviousAccount(state, payload) {
    state.previousAccount = payload;
  },

  mutationLocale(state, payload) {
    state.locale = payload;
  },

  mutationHeaderTableColumn(state, payload) {
    state.headerTableColumn = payload;
  },

  mutationPlatformConfigFilter(state, payload) {
    state.platformConfigFilter = payload;
  },

  mutationInternalToolsFilter(state, payload) {
    state.internalToolsFilter = payload;
  },
};

export default mutations;
